export default __webpack_public_path__ + "images/9a1362ce72abb173cc349f426a27437c.png";